import React from 'react'

export default function () {
	return (
		<svg width="21px" height="21px" viewBox="0 0 21 21" version="1.1">
			<path d="M20.2369863,1.00959961 L15.9713613,0.0253476562 C15.5073105,-0.0817441406 15.0329648,0.158730469 14.8452363,0.596736328 L12.8764863,5.19036328 C12.7037248,5.59348176 12.8184922,6.06226864 13.1579355,6.33999023 L15.6441797,8.37420117 C14.1687246,11.5190742 11.5861758,14.1372246 8.37420117,15.6441387 L6.33999023,13.1579355 C6.06226864,12.8184922 5.59348176,12.7037248 5.19036328,12.8764863 L0.596736328,14.8452363 C0.158853516,15.0328828 -0.0817851562,15.5071875 0.0253476563,15.9713613 L1.00959961,20.2369863 C1.11189258,20.6802422 1.50724219,21 1.96875,21 C12.4723184,21 21,12.4879453 21,1.96875 C21,1.51035937 20.6836055,1.11263086 20.2369863,1.00959961 Z"></path>
		</svg>
	)
}
